




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import CheckoutContainer from './CheckoutContainer.vue';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    CheckoutContainer
  }
})
export default class CheckoutReRenderer extends Vue {
  @CheckoutModule.State(state => state.reRenderKey)
  private reRenderKey: number;
}
